import { useState, useEffect } from 'react';

export interface UserProfile {
  version?: number;
  id: string;
  name: string;
  bio: string;
  avatar: string | null;
  details?: {
    fullName?: string;
    phone?: string;
    location?: string;
  };
  settings: {
    darkMode: boolean;
    notifications: boolean;
    prayerAlerts: boolean;
    kidsMode: boolean;
  };
}

const defaultProfile: UserProfile = {
  version: 2, 
  id: '', 
  name: 'Username',
  bio: 'Seeking the pleasure of Allah.',
  avatar: null,
  details: {
    fullName: '',
    phone: '',
    location: '',
  },
  settings: {
    darkMode: false,
    notifications: true,
    prayerAlerts: true,
    kidsMode: false,
  },
};

export function useProfile() {
  const [profile, setProfile] = useState<UserProfile>(defaultProfile);

  useEffect(() => {
    // 1. Load Local
    const saved = localStorage.getItem('habl_profile');
    let loadedProfile = defaultProfile;
    
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.version === 2) {
          loadedProfile = { ...defaultProfile, ...parsed };
        } else {
          loadedProfile = defaultProfile; 
        }
      } catch (e) {
        console.error('Failed to parse profile', e);
      }
    }

    if (!loadedProfile.id) {
      loadedProfile.id = crypto.randomUUID();
      localStorage.setItem('habl_profile', JSON.stringify(loadedProfile));
    }

    setProfile(loadedProfile);
  }, []);

  const saveProfile = async (updated: UserProfile) => {
    setProfile(updated);
    localStorage.setItem('habl_profile', JSON.stringify(updated));
  };

  const updateProfile = (updates: Partial<UserProfile>) => {
    setProfile(prev => {
      let newDetails = prev.details;
      if (updates.details) {
          newDetails = { ...prev.details, ...updates.details };
      }

      const updated = { 
          ...prev, 
          ...updates,
          details: newDetails 
      };
      saveProfile(updated);
      return updated;
    });
  };

  const updateSettings = (settingsUpdates: Partial<UserProfile['settings']>) => {
    setProfile(prev => {
      const updated = { 
        ...prev, 
        settings: { ...prev.settings, ...settingsUpdates } 
      };
      saveProfile(updated);
      return updated;
    });
  };

  return { profile, updateProfile, updateSettings };
}
